import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '@/views/HomeView.vue'
import PersonView from '@/views/user/PersonView'
import CourseView from '@/views/course/CourseView'
import ErrorView from '@/views/ErrorView'
import LoginView from '@/views/user/LoginView'
import RegisterView from '@/views/user/RegisterView'
import BackendView from '@/views/backend/BackendView'
import CourseListView from '@/views/backend/course/CourseListView'
import CourseAllView from '@/views/backend/course/CourseAllView'
import CateView from '@/views/backend/cate/CateView'
import MyCourseView from '@/views/backend/course/MyCourseView'
import VideoView from '@/views/video/VideoView'
import AllUserView from '@/views/backend/user/AllUserView'
import BatchAddStuView from '@/views/backend/user/BatchAddStuView'
import BatchAddTeaView from '@/views/backend/user/BatchAddTeaView'
import OptionView from '@/views/backend/options/OptionView'
import CourseDetailView from '@/views/course/CourseDetailView'
import LearnCourseView from '@/views/course/LearnCourseView'
import ProblemSettingView from '@/views/backend/course/ProblemSettingView'
import LearnHomeworkView from '@/views/course/Homework/LearnHomeworkView'
import CorrectHomeworkView from '@/views/course/Homework/CorrectHomeworkView'
import ManualCorrectExamView from '@/views/course/Homework/ManualCorrectExamView'
import LearnExamView from '@/views/course/exam/LearnExamView'
import ExamOverView from '@/views/course/exam/ExamOverView'
import ApplyListView from '@/views/backend/course/ApplyListView'
import CertificaStuView from '@/views/backend/course/CertificaStuView'
import StudentManagerView from '@/views/backend/user/StudentManagerView'
import SelectCertificaView from '@/views/course/SelectCertificaView'
import PersonInfoView from '@/views/user/PersonInfoView'
import ProfessionalCertificaView from '@/views/backend/course/ProfessionalCertificaView'
import CourseCertificaView from '@/views/backend/course/CourseCertificaView'
import LearnProfessionalView from '@/views/course/LearnProfessionalView'
import ApplyProfessionalView from '@/views/course/ApplyProfessionalView'
import SelectProfessionalView from '@/views/course/SelectProfessionalView'

import { useStore } from 'vuex'

const routes = [
  {
    path: '/',
    name: 'home',
    redirect: "/index/",
    meta: {
      requestAuth: false,
    }
  },
  {
    path: '/index/',
    name: 'index',
    component: HomeView,
    meta: {
      requestAuth: false,
    },
  },
  {
    path: '/personInfo/',
    name: 'personInfo',
    component: PersonInfoView,
    meta: {
      requestAuth: false,
    },
  },
  {
    path: '/login/',
    name: 'login',
    component: LoginView,
    meta: {
      requestAuth: false,
    }
  },
  {
    path: '/ManualCorrectExam/:recordId?/:courseId?/',
    name: 'ManualCorrectExam',
    component: ManualCorrectExamView,
    meta: {
      requestAuth: true,
    }
  },
  {
    path: '/LearnProfessional/:page?/:keyword?/',
    name: 'LearnProfessional',
    component: LearnProfessionalView,
    meta: {
      requestAuth: true,
    }
  },
  {
    path: '/ApplyProfessional/:professionalId?/',
    name: 'ApplyProfessional',
    component: ApplyProfessionalView,
    meta: {
      requestAuth: true,
    }
  },
  {
    path: '/SelectCertifica/',
    name: 'SelectCertifica',
    component: SelectCertificaView,
    meta: {
      requestAuth: true,
    }
  },
  {
    path: '/SelectProfessional/',
    name: 'SelectProfessional',
    component: SelectProfessionalView,
    meta: {
      requestAuth: true,
    }
  },
  {
    path: '/ExamOver/',
    name: 'ExamOver',
    component: ExamOverView,
    meta: {
      requestAuth: true,
    }
  },
  {
    path: '/CorrectHomework/:examId?/:courseId?/:page?/:keyword?/',
    name: 'CorrectHomework',
    component: CorrectHomeworkView,
    meta: {
      requestAuth: true,
    }
  },
  {
    path: '/LearnExam/:examId?/:courseId?/',
    name: 'LearnExam',
    component: LearnExamView,
    meta: {
      requestAuth: true,
    }
  },
  {
    path: '/LearnHomework/:examId?/:courseId?/',
    name: 'LearnHomework',
    component: LearnHomeworkView,
    meta: {
      requestAuth: true,
    }
  },
  {
    path: '/video/:courseId?/:videoId?/',
    name: 'video',
    component: VideoView,
    meta: {
      requestAuth: true,
    }
  },
  {
    path: '/ProblemSetting/:homeworkId?/:courseId?/',
    name: 'ProblemSetting',
    component: ProblemSettingView,
    meta: {
      requestAuth: true,
    }
  },
  {
    path: '/learnCourse/:courseId?/',
    name: 'learnCourse',
    component: LearnCourseView,
    meta: {
      requestAuth: true,
    }
  },
  {
    path: '/CourseDetail/:courseId?/',
    name: 'CourseDetail',
    component: CourseDetailView,
    meta: {
      requestAuth: true,
    }
  },
  {
    path: '/backend/',
    name: 'backend',
    component: BackendView,
    meta: {
      requestAuth: true,
    }, 
    children:[
      {
        path:'/backend/OptionView',
        name: 'OptionView',
        component: OptionView,
        meta: {
          requestAuth: true,
        },
        props: true // 启用将路由参数作为组件属性传递的功能
      },
      {
        path:'/backend/CourseList/:page',
        name: 'CourseList',
        component: CourseListView,
        meta: {
          requestAuth: true,
        },
        props: true // 启用将路由参数作为组件属性传递的功能
      },
      {
        path:'/backend/BatchAddTea',
        name: 'BatchAddTea',
        component: BatchAddTeaView,
        meta: {
          requestAuth: true,
        },
        props: true // 启用将路由参数作为组件属性传递的功能
      },
      {
        path:'/backend/BatchAddStu/',
        name: 'BatchAddStu',
        component: BatchAddStuView,
        meta: {
          requestAuth: true,
        },
        props: true // 启用将路由参数作为组件属性传递的功能
      },
      {
        path:'/backend/ApplyList/:page?/:courseId?',
        name: 'ApplyList',
        component: ApplyListView,
        meta: {
          requestAuth: true,
        },
        props: true // 启用将路由参数作为组件属性传递的功能
      },
      {
        path:'/backend/ProfessionalCertifica/:page?/:keyword?/',
        name: 'ProfessionalCertifica',
        component: ProfessionalCertificaView,
        meta: {
          requestAuth: true,
        },
        props: true // 启用将路由参数作为组件属性传递的功能
      },
      {
        path:'/backend/CourseCertifica/:page?/:professionalId?/:courseName?/',
        name: 'CourseCertifica',
        component: CourseCertificaView,
        meta: {
          requestAuth: true,
        },
        props: true // 启用将路由参数作为组件属性传递的功能
      },
      {
        path:'/backend/AllUser/:page/:keyword?',
        name: 'AllUser',
        component: AllUserView,
        meta: {
          requestAuth: true,
        },
        props: true // 启用将路由参数作为组件属性传递的功能
      },
      {
        path:'/backend/MyCourse/:courseId',
        name: 'MyCourse',
        component: MyCourseView,
        meta: {
          requestAuth: true,
        },
        props: true // 启用将路由参数作为组件属性传递的功能
      },
      {
        path:'/backend/CourseAllView/:page?/:cateId?/:courseName?',
        name: 'CourseAllView',
        component: CourseAllView,
        meta: {
          requestAuth: true,
        }
      },
      {
        path:'/backend/CertificaStu/:userId?/:courseId?',
        name: 'CertificaStu',
        component: CertificaStuView,
        meta: {
          requestAuth: true,
        }
      },
      {
        path:'/backend/StudentManager/:courseId?/:keyword?/',
        name: 'StudentManager',
        component: StudentManagerView,
        meta: {
          requestAuth: true,
        }
      },
      {
        path:'/backend/CateView/:page',
        name: 'CateView',
        component: CateView,
        meta: {
          requestAuth: true,
        },
        props: true // 启用将路由参数作为组件属性传递的功能
      },
    ]

  },
  {
    path: '/register/',
    name: 'register',
    component: RegisterView,
    meta: {
      requestAuth: false,
    }
  },
  {
    path: '/person/',
    name: 'person',
    component: PersonView,
    meta: {
      requestAuth: true,
    }
  },
  {
    path: '/course/:page?/:cateId?/:courseName?',
    name: 'course',
    component: CourseView,
    meta: {
      requestAuth: false,
    },
    props: true // 启用将路由参数作为组件属性传递的功能
  },
  {
    path: "/404/",
    name: "404",
    component: ErrorView,
    meta: {
      requestAuth: false,
    }
  },
  {
    path: "/:catchAll(.*)",
    redirect: "/404/"
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
});

router.beforeEach((to, from, next) => {

  const store = useStore();

  // 获取token
  let token = localStorage.getItem("token");
  // 判断跳转的连接是否需要授权
  if (to.meta.requestAuth) {
    // 判断token是否为空
    if (token) {
      // 根据token拉取用户信息
      store.dispatch("getUserInfo", {
        "token": token,
        success(msg) {
            console.log(msg);
            next();
        },
        error(msg) {
          console.log(msg);
        },
      });
      // 拉取成功后跳转

      // 拉取失败后跳转登录界面
      
    } else {
      // 否则跳转至登录界面
      next({name: "login"});
    }

  } else {
    // 不需要授权直接跳转即可
    if (token) {
      // 根据token拉取用户信息
      store.dispatch("getUserInfo", {
        "token": token,
        success(msg) {
            console.log(msg);
            next();
        },
        error(msg) {
          console.log(msg);
        }
      })}
    next();
  }
})




export default router
